<template>
    <div class="main-div">
        <el-row justify="end" class="headbar">
            <el-col :span="4" />
            <el-col :span="20">
                <el-form
                    :model="args"
                    class="search-form" :inline="true">
                    <el-form-item label="" prop="query" style="width: 250px;">
                        <el-input
                            v-model="args.query"
                            autocomplete="off"
                            placeholder="查询"
                            clearable
                            maxlength="32"
                            @change="load_data" />
                    </el-form-item>
                    <el-form-item style="width: 46px;">
                        <el-button
                            type="primary"
                            @click="load_data">
                            <el-icon><Search /></el-icon>
                        </el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <el-row class="content">
            <el-table
                ref="elTable"
                :data="data.slice((page-1)*rspp,page*rspp)"
                :highlight-current-row="true"
                :border="true"
                :row-key="row => row.id"
                :expand-row-keys="expand_row_keys"
                @expand-change="on_expand_change">
                <el-table-column fixed type="expand">
                    <template #default="props">
                        <div>
                            <span v-for="user in props.row.users" :key="user.id">
                                {{ user.name }}
                            </span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column fixed type="index" align="center" />
                <el-table-column
                    v-for="(col, i) in tableCols"
                    :key="i"
                    :fixed="!i"
                    :label="col.label"
                    v-bind="col"
                    header-align="center"
                    :align="col.align" />
                <el-table-column />
                <el-table-column fixed="right" label="" width="80" align="center">
                    <template #header>
                        <el-tooltip content="添加" placement="top">
                            <el-button
                                link
                                type="primary"
                                @click="add_item()">
                                <el-icon><plus /></el-icon>
                            </el-button>
                        </el-tooltip>
                    </template>
                    <template #default="item">
                        <el-tooltip content="修改" placement="top">
                            <el-button
                                link
                                type="primary"
                                size="large"
                                @click="mod_item($event, item.row)">
                                <el-icon><edit /></el-icon>
                            </el-button>
                        </el-tooltip>
                        <el-tooltip content="删除" placement="top">
                            <el-button
                                link
                                type="primary"
                                size="small"
                                @click="del_item($event, item.row)">
                                <el-icon><delete /></el-icon>
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row class="pagebar">
            <el-pagination
                align="center"
                :current-page="page"
                :page-sizes="[10,20,50,999]"
                :page-size="rspp"
                layout="total, sizes, prev, pager, next, jumper"
                :total="user_list.length"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange" />
        </el-row>
    </div>
    <DialogItem ref="DialogItem" />
</template>
<script>
import {dict, notify} from '../../assets/js/utils.js';
import {try_catch} from '../../assets/js/async.js';
import {Search, Edit, Plus, Delete} from '@element-plus/icons-vue';
import DialogItem from './dlg-corporation.vue';
import UserStore from '../../stores/user.js';
import {formatToBJ} from '../../assets/js/time.js';

export default {
    name: 'CorpList',
    components: {
        Search,
        Edit,
        Plus,
        Delete,
        DialogItem,
    },
    data: function() {
        return {
            args: {
                query: '',
            },
            data: [],
            expand_row_keys: [],
            user_list: [],
            corp_list: null,
            page: 1, // 当前页码
            rspp: 20, // 每页的数据条数
        };
    },
    computed: {
        userstore() {
            return UserStore();
        },
        tableCols() {
            return [
                {
                    prop: 'code',
                    label: '编码',
                    width: 100,
                    align: 'center',
                },
                {
                    prop: 'name',
                    label: '名称',
                    width: 200,
                    align: 'center',
                },
                {
                    prop: 'valid_date',
                    label: '有效期',
                    width: 100,
                    align: 'center',
                },
                {
                    prop: 'state_name',
                    label: '状态',
                    width: 80,
                    align: 'center',
                },
                {
                    prop: 'created_at_show',
                    label: '创建时间',
                    width: 160,
                    align: 'center',
                },
            ];
        },
    },
    beforeMount() {
        this.load_data();
    },
    methods: {
        // on_expand_change(row, _children) {
        on_expand_change(row) {
            const key = row.id;
            const index = this.expand_row_keys.indexOf(key);
            if (index < 0) {
                this.expand_row_keys.push(key);
            } else {
                this.expand_row_keys.splice(index, 1);
            }
        },
        async add_item() {
            return await try_catch(async () => {
                const data = await this.$refs.DialogItem.show({
                    data: {
                        id: null,
                        code: '',
                        name: '',
                        valid_date: '',
                        state: '1',
                    },
                    list: this.data,
                });
                console.debug(data);
                this.load_data();
            });
        },
        async mod_item(_, row) {
            return await try_catch(async () => {
                const data = await this.$refs.DialogItem.show({
                    data: row,
                    list: this.user_list,
                });
                console.debug(data);
                this.load_data();
            });
        },
        async del_item(_, row) {
            return await try_catch(async () => {
                await this.$confirm(`确定要删除 "${row.name}"`, '删除提示', {
                    iconClass: 'el-icon-question', // 自定义图标样式
                    confirmButtonText: '确认', // 确认按钮文字更换
                    cancelButtonText: '取消', // 取消按钮文字更换
                    showClose: true, // 是否显示右上角关闭按钮
                    type: 'warning', // 提示类型  success/info/warning/error
                });
                const url = `/admin/api/corporations/${row.id}`;
                const res = await this.axios.delete(url);
                if (res.data.result) {
                    notify('success', '删除成功', 0);
                } else {
                    notify('error', res.data.error, 0);
                }
                this.load_data();
            });
        },

        async load_data() {
            await try_catch(async () => {
                const url = `/admin/api/corporations`;
                const args = dict([['q', this.args.query]].filter((_, v) => !!v));
                const res = await this.axios.get(url, {parameters: args});
                const data = res.data.data;
                const states = {true: '活跃', false: '冻结'};
                data.forEach(x => {
                    x.created_at_show = formatToBJ(x.created_at);
                    x.state_name = states[x.state > 0];
                });
                this.data.length = 0;
                this.data.push(...data);
            });
        },
        handleSizeChange(val) {
            this.page = 1;
            this.rspp = val;
        },
        // 当前页改变时触发 跳转其他页
        handleCurrentChange(val) {
            this.page = val;
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-div{
    display: flex;
    position: relative;
    width: 100%;
    height: 100%;
    flex-direction: column;
}
.headbar {
}
.footbar {
}
.content {
    height: 100px;
    flex-grow: 1;
}
.search-form {
    text-align: right;
}
.search-form>.el-form-item {
    margin-bottom: 0;
    margin-right: 0;
    width: 150px;
}
</style>
